function Testimonials({ testimonials, setTestimonials, sectionId }) {
  return null;
}

export default Testimonials;
